import { ExternalLink, Download } from "lucide-react";
import { BACKEND, fmtDate } from "@/lib/api";
const STYLE = { SUPPORTED: "bg-emerald-50 text-emerald-800 border-emerald-200", CONTRADICTED: "bg-rose-50 text-rose-800 border-rose-200", MIXED: "bg-amber-50 text-amber-800 border-amber-300", "INSUFFICIENT EVIDENCE": "bg-stone-100 text-stone-700 border-stone-300" };
const LABEL = { SUPPORTED: "Supported by approved sources", CONTRADICTED: "Contradicted by approved sources", MIXED: "Approved sources disagree", "INSUFFICIENT EVIDENCE": "Not enough evidence yet" };

export const SharedClaim = ({ c }) => (
  <article className="surface space-y-4 p-6" data-testid="share-claim">
    <p className="text-xs font-semibold uppercase tracking-wider text-[hsl(var(--facts))]">Middle fact check</p>
    <span data-testid="share-claim-verdict" className={`inline-flex rounded-full border px-3 py-1 text-xs font-semibold ${STYLE[c.verdict] || STYLE["INSUFFICIENT EVIDENCE"]}`}>{LABEL[c.verdict]}</span>
    <h1 className="font-serif text-3xl leading-tight" data-testid="share-claim-text">“{c.text}”</h1>
    {c.explanation && <p className="text-slate-700">{c.explanation}</p>}
    {(c.sources || []).length > 0 && (
      <div className="space-y-2" data-testid="share-claim-sources">
        {c.sources.map((s) => (
          <a key={s.id} href={s.url || undefined} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between gap-3 rounded-xl border p-3 text-sm hover:border-slate-400">
            <span><b>{s.source || "Approved source"}</b> · {s.title}{s.stance === "conflicts" ? " (conflicts)" : ""}</span><ExternalLink size={15} className="shrink-0" />
          </a>
        ))}
      </div>
    )}
    <div className="flex flex-wrap items-center justify-between gap-2">
      <p className="text-xs text-slate-500">Checked {fmtDate(c.checked_at)} only against Middle's approved sources.</p>
      <a href={`${BACKEND}/api/public/claims/${c.id}/card.png`} download={`middle-fact-check-${c.id.slice(0, 8)}.png`} className="inline-flex items-center gap-1 text-xs font-medium text-[hsl(var(--facts))] hover:underline" data-testid="share-claim-image"><Download size={12} />Save as image</a>
    </div>
  </article>
);
